import { useUI } from '@/store/ui'
import { useAuth } from '@/store/auth'

/** Sign out at the gate — the ONE door (founder ruling 2026-08-04).
 *
 *  Under code-handoff the Daemon mints Apex's OWN ``apex_session`` cookie, so
 *  signing out is two steps: end the LOCAL session first (POST /auth/logout,
 *  which clears both apex_session AND the legacy shared warden_session — the
 *  gate's /logout only ends the gate's cookie, not ours), then bounce to the
 *  gate's /logout so the suite-wide session ends too (one-logout-everywhere).
 *  The local step is best-effort: even if it fails, the gate /logout still ends
 *  the shared session, so we always navigate. With APEX_GATE_SSO off there is no
 *  apex_session to clear, and this degrades to exactly the old behaviour.
 *  The gate URL comes from the same setting the 401 bounce uses (store/ui).
 */
export function SignOutButton({
  navigate = (url: string) => window.location.assign(url),
  onSignOut,
}: {
  navigate?: (url: string) => void
  /** Injectable local sign-out for tests; defaults to the auth store's logout. */
  onSignOut?: () => Promise<void>
}) {
  const gateUrl = useUI((s) => s.gateUrl)
  const storeLogout = useAuth((s) => s.logout)

  async function signOut() {
    try {
      await (onSignOut ?? storeLogout)()
    } catch {
      // best-effort — the gate's /logout still ends the suite-wide session
    }
    // Carry Apex's origin so the gate's sign-in keeps the Apex plate.
    const next = encodeURIComponent(`${window.location.origin}/`)
    navigate(`${gateUrl.replace(/\/+$/, '')}/logout?next=${next}`)
  }

  return (
    <button
      type="button"
      className="iv-nav-item ap-signout"
      onClick={() => {
        void signOut()
      }}
    >
      Sign out
    </button>
  )
}
